<div class="row d-flex w-100 mt-3 p2p-info-container">
    <div [ngClass]="col12" class="col-7 p2p-info-container--grey">
        <div>
            <span class="subtitle-1--weight-bold">{{name}}</span>
            <br>
            <span class="body-3 grey-text font-weight-400">{{email}}</span>
        </div>
        <div class="row mt-2">
            @if(showPhone) {
                <div [ngClass]="{'col-12': !donorAddressText}" class="col-5">
                    <span class="subtitle-2">Phone</span>
                    <br>
                    <span class="subtitle-2--regular">{{phone}}</span>
                </div>
            }
            @if(showStreetAddress) {
                <div [ngClass]="{'col-12': !phone}" class="col-7">
                    <span class="subtitle-2">Street Address</span>
                    <br>
                    <span class="subtitle-2--regular">{{donorAddressText}}</span>
                </div>
            }
        </div>
    </div>

    @if(showAdditionalInfo || showAdditionalInfoSelect) {
        <div class="col-5 p2p-info-container--white">
            @if(showAdditionalInfo) {
                <div class="mb-2">
                    <span class="d-flex subtitle-2 mb-1">{{campaign.additionalInfoDesc}}</span>
                    <app-read-more [text]="donation.campaignAdditionalInfo" [options]="readMoreOptions" class="subtitle-2--regular"></app-read-more>
                </div>
            }
            @if(showAdditionalInfoSelect) {
                <div>
                    <span class="d-flex subtitle-2 mb-1">{{campaign.additionalInfoSelectDesc}}</span>
                    <app-read-more [text]="donation.additionalInfoSelected" [options]="readMoreOptions" class="subtitle-2--regular"></app-read-more>
                </div>
            }
        </div>
    }
</div>

@for (fundraiser of uniqFundraisers; track fundraiser.id; let index = $index) {
    <app-p2p-donor-details-card (selectedFundraiser)="fundraiserSelected($event)" [fundraiser]="fundraiser" [donor]="donation" [index]="index"></app-p2p-donor-details-card>
}
